export const shared = {
   apiVersion: 'v1',
   clientVersion: '8.0.3',
   copyright: '© 2024-2026 Quick Crypt Contributors',
};
